import React, { useEffect, useState } from 'react';
import PropTypes, { any } from 'prop-types';
import kebabCase from 'lodash/kebabCase';
import { eventTrack, FOOTER_LINK_CLICK } from 'utils/google-tag-manager';
import { isXSmallToMedium } from 'styles/media-queries';
import { debounce } from 'lodash';
import { ThemeProvider } from 'styled-components';
import { ICONS } from 'constants/icons';
import * as Styled from './Footer.styled';

const RESIZE_DEBOUNCE_DELAY = 250;

export const FooterLinkGroup = ({ links, groupTitle }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(isXSmallToMedium());

    const onResize = debounce(() => {
      setIsMobile(isXSmallToMedium());
      if (!isMobile && !isOpen) {
        setIsOpen(true);
      }
    }, RESIZE_DEBOUNCE_DELAY);

    window.addEventListener('resize', onResize);

    return () => {
      onResize.cancel();
      window.removeEventListener('resize', onResize);
    };
  }, [isMobile, isOpen]);

  return (
    <ThemeProvider
      theme={{
        isOpen,
        isMobile,
      }}
    >
      <Styled.LinkCollectionItem>
        <Styled.LinkCollectionTitle onClick={() => setIsOpen(!isOpen)}>
          {groupTitle}
          <Styled.Caret name={ICONS.CARET_DOWN} />
        </Styled.LinkCollectionTitle>
        <Styled.LinkCollection>
          {links &&
            links.map(({ title: linkTitle, url }) => (
              <Styled.LinkContainer key={kebabCase(`${linkTitle} ${url}`)}>
                <Styled.LinkComponent
                  href={url}
                  asLink={url}
                  onClick={event => {
                    eventTrack(FOOTER_LINK_CLICK, {
                      event,
                      href: url,
                      columnName: groupTitle,
                    });
                  }}
                >
                  {linkTitle}
                </Styled.LinkComponent>
              </Styled.LinkContainer>
            ))}
        </Styled.LinkCollection>
      </Styled.LinkCollectionItem>
    </ThemeProvider>
  );
};

FooterLinkGroup.propTypes = {
  /**
   * Links in the link group
   */
  links: PropTypes.arrayOf(any).isRequired,
  /**
   * Link group title
   */
  groupTitle: PropTypes.string.isRequired,
};
